import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";
import * as cookie from "../utils/cookies";

/**
     * Gibt alle Kalender zurück.
     */
export function getCalendars(ids: number[] = []): JQueryPromise<modelsGet.ICalendar[]>
{
    var endpoint = new URI("api/calendars");

    if (ids.length > 0)
    {
        endpoint.addSearch("ids", ids.join(","));
    }

    return api.get<modelsGet.ICalendar[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt einen bestimmten Kalender anhand einer ID zurück.
 * @param id
 */
export function getCalendar(id: number): JQueryPromise<modelsGet.ICalendar>
{
    var endpoint = new URI("api/calendars");
    endpoint.segment(id.toString());

    return api.get<modelsGet.ICalendar>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt den momentan selektierten Kalender oder die Kalendergruppe zurück.
 */
export function getSelectedObject(): JQueryPromise<modelsGet.ICalendarOrGroup>
{
    var lastSelection = cookie.getLastSelection();
    var endpoint: uri.URI = new URI("api/calendars/selected");

    endpoint.addQuery({
        objectId: lastSelection.objectId,
        isGroup: lastSelection.metadata.is_group,
        meta: JSON.stringify(lastSelection.metadata).toBase64urlString()
    });

    return api.get<modelsGet.ICalendarOrGroup>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(calendar: modelsPost.ICalendar): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/calendars/create",
        data: JSON.stringify(calendar)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, calendar: modelsPost.ICalendar): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/calendars/edit/${id}`,
        data: JSON.stringify(calendar)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/calendars/delete/${id}`
    });
}